import axios from 'axios';
import { campaignCloseUrl, campaignPauseUrl, campaignResumeUrl, dashboardUrl } from '../../configurations/api/url';
import type { UgcBoardFacet, UgcBoardListResponse, UgcCampaignPauseResponse } from '../../types/global/ugcBoard.types';

export interface FetchUgcBoardParams {
    page?: number;
    limit?: number;
    sort?: number;
    searchTerm?: string;
    token: string;
    signal?: AbortSignal;
}

export async function fetchUgcBoard({
    page = 1,
    limit = 20,
    sort = -1,
    searchTerm,
    token,
    signal,
}: FetchUgcBoardParams): Promise<UgcBoardFacet> {
    const params: Record<string, string> = {
        category: 'ugc',
        page: String(page),
        limit: String(limit),
        sort: String(sort),
    };
    if (searchTerm?.trim()) params.searchTerm = searchTerm.trim();

    const { data } = await axios.get<UgcBoardListResponse>(dashboardUrl, {
        params,
        headers: { Authorization: `Bearer ${token}` },
        signal,
    });
    return data.data.ugc;
}

export async function pauseUgcCampaign(
    campaignId: string,
    reason: string,
    token: string,
): Promise<UgcCampaignPauseResponse['data']> {
    const { data } = await axios.patch<UgcCampaignPauseResponse>(
        campaignPauseUrl(campaignId),
        { reason },
        { headers: { Authorization: `Bearer ${token}` } },
    );
    return data.data;
}

export async function resumeUgcCampaign(campaignId: string, token: string): Promise<void> {
    await axios.patch(campaignResumeUrl(campaignId), null, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export async function closeUgcCampaign(campaignId: string, token: string): Promise<{ escrow_released_cents?: number }> {
    const { data } = await axios.post(
        campaignCloseUrl(campaignId),
        {},
        { headers: { Authorization: `Bearer ${token}` } },
    );
    return data?.data ?? {};
}
